import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterByDeliveryType' })
export class FilterByDeliveryTypePipe implements PipeTransform {
  transform(subProducts: any[], selectedDeliveryTypes: string[]): any[] {
    if (!selectedDeliveryTypes || selectedDeliveryTypes.length === 0) {
      return subProducts; // Show all if none selected
    }
    return subProducts.filter(sp => selectedDeliveryTypes.includes(sp.deliveryType));
  }
}